'use client';

import { AboutTag } from '@/graphql/gql/about/graphql';
import { createContext, useContext, ReactNode, useMemo } from 'react';

type TagsContextType = {
  tags: AboutTag[];
};

const TagsContext = createContext<TagsContextType | undefined>(undefined);

export function TagsProvider({
  children,
  tags,
}: Readonly<{
  children: ReactNode;
  tags: AboutTag[];
}>) {
  const contextValue = useMemo(() => ({ tags }), [tags]);
  return (
    <TagsContext.Provider value={contextValue}>{children}</TagsContext.Provider>
  );
}

export function useTagsContext(): TagsContextType {
  const context = useContext(TagsContext);
  if (context === undefined) {
    throw new Error('useTagsContext must be used within a TagsProvider');
  }
  return context;
}
